<script>
    export let items
    export let active = -1

    function toggle(id) {
        return () => {
            active = active === id ? -1 : id
        }
    }
</script>
<div class="ui styled fluid accordion">
    {#each items as item (item.id)}
        <div class="title" class:active={item.id === active} on:click={toggle(item.id)}>
            <slot name="title" item={item}></slot>
        </div>
        <div class="content" class:active={item.id === active}>
            <slot name="content" item={item}></slot>
        </div>
    {/each}
</div>
